// @generated by protoc-gen-es v1.10.0 with parameter "target=ts"
// @generated from file gdx/gateway/web/compatibility/v1/compatibility.proto (package gdx.compatibility.v1, syntax proto3)
/* eslint-disable */
// @ts-nocheck

import type { BinaryReadOptions, FieldList, JsonReadOptions, JsonValue, PartialMessage, PlainMessage } from "@bufbuild/protobuf";
import { Message, proto3, protoInt64 } from "@bufbuild/protobuf";

/**
 * Describe general content and each sign description.
 *
 * @generated from message gdx.compatibility.v1.Content
 */
export class Content extends Message<Content> {
  /**
   * @generated from field: string your_sign = 1;
   */
  yourSign = "";

  /**
   * @generated from field: string partner_sign = 2;
   */
  partnerSign = "";

  /**
   * @generated from field: string general = 3;
   */
  general = "";

  constructor(data?: PartialMessage<Content>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gdx.compatibility.v1.Content";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "your_sign", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "partner_sign", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "general", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): Content {
    return new Content().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): Content {
    return new Content().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): Content {
    return new Content().fromJsonString(jsonString, options);
  }

  static equals(a: Content | PlainMessage<Content> | undefined, b: Content | PlainMessage<Content> | undefined): boolean {
    return proto3.util.equals(Content, a, b);
  }
}

/**
 * Describe sexual compatibility between you and partner.
 *
 * @generated from message gdx.compatibility.v1.SexualCompatibility
 */
export class SexualCompatibility extends Message<SexualCompatibility> {
  /**
   * @generated from field: string your_gender = 1;
   */
  yourGender = "";

  /**
   * @generated from field: string partner_gender = 2;
   */
  partnerGender = "";

  /**
   * @generated from field: string content = 3;
   */
  content = "";

  constructor(data?: PartialMessage<SexualCompatibility>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gdx.compatibility.v1.SexualCompatibility";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "your_gender", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "partner_gender", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "content", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): SexualCompatibility {
    return new SexualCompatibility().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): SexualCompatibility {
    return new SexualCompatibility().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): SexualCompatibility {
    return new SexualCompatibility().fromJsonString(jsonString, options);
  }

  static equals(a: SexualCompatibility | PlainMessage<SexualCompatibility> | undefined, b: SexualCompatibility | PlainMessage<SexualCompatibility> | undefined): boolean {
    return proto3.util.equals(SexualCompatibility, a, b);
  }
}

/**
 * Describe compatibility between you and partner.
 *
 * @generated from message gdx.compatibility.v1.Compatibility
 */
export class Compatibility extends Message<Compatibility> {
  /**
   * @generated from field: string your_sign = 1;
   */
  yourSign = "";

  /**
   * @generated from field: string partner_sign = 2;
   */
  partnerSign = "";

  /**
   * @generated from field: gdx.compatibility.v1.Content content = 3;
   */
  content?: Content;

  /**
   * @generated from field: int64 percentage = 4;
   */
  percentage = protoInt64.zero;

  constructor(data?: PartialMessage<Compatibility>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gdx.compatibility.v1.Compatibility";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "your_sign", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "partner_sign", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "content", kind: "message", T: Content },
    { no: 4, name: "percentage", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): Compatibility {
    return new Compatibility().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): Compatibility {
    return new Compatibility().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): Compatibility {
    return new Compatibility().fromJsonString(jsonString, options);
  }

  static equals(a: Compatibility | PlainMessage<Compatibility> | undefined, b: Compatibility | PlainMessage<Compatibility> | undefined): boolean {
    return proto3.util.equals(Compatibility, a, b);
  }
}

/**
 * Describe price of compatibility feature.
 *
 * @generated from message gdx.compatibility.v1.Price
 */
export class Price extends Message<Price> {
  /**
   * @generated from field: uint64 price_credits = 1;
   */
  priceCredits = protoInt64.zero;

  /**
   * @generated from field: bool is_free = 2;
   */
  isFree = false;

  constructor(data?: PartialMessage<Price>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gdx.compatibility.v1.Price";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "price_credits", kind: "scalar", T: 4 /* ScalarType.UINT64 */ },
    { no: 2, name: "is_free", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): Price {
    return new Price().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): Price {
    return new Price().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): Price {
    return new Price().fromJsonString(jsonString, options);
  }

  static equals(a: Price | PlainMessage<Price> | undefined, b: Price | PlainMessage<Price> | undefined): boolean {
    return proto3.util.equals(Price, a, b);
  }
}

/**
 * Compatibility unavailable by some reason.
 *
 * @generated from message gdx.compatibility.v1.Unavailable
 */
export class Unavailable extends Message<Unavailable> {
  constructor(data?: PartialMessage<Unavailable>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gdx.compatibility.v1.Unavailable";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): Unavailable {
    return new Unavailable().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): Unavailable {
    return new Unavailable().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): Unavailable {
    return new Unavailable().fromJsonString(jsonString, options);
  }

  static equals(a: Unavailable | PlainMessage<Unavailable> | undefined, b: Unavailable | PlainMessage<Unavailable> | undefined): boolean {
    return proto3.util.equals(Unavailable, a, b);
  }
}

